"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonTypes = void 0;
/**
 * @deprecated removed
 */
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["Default"] = "default";
    ButtonTypes["Raised"] = "raised";
    ButtonTypes["Flat"] = "flat";
    ButtonTypes["Stroked"] = "stroked";
    ButtonTypes["Icon"] = "icon";
    ButtonTypes["Fab"] = "fab";
    ButtonTypes["MiniFab"] = "mini-fab";
})(ButtonTypes || (exports.ButtonTypes = ButtonTypes = {}));
